import { Settings } from 'luxon';

Settings.defaultLocale = 'en';
